module.exports = __webpack_public_path__ + "static/media/YM57_0.0bf77d04.jpg";